<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 5C18.0751 5 23 9.30769 23 12C23 14.6923 18.0751 19 12 19C5.92487 19 1 14.6923 1 12C1 9.30769 5.92487 5 12 5ZM12 7C9.60476 7 7.23713 7.80223 5.37974 9.1211C3.87775 10.1876 3 11.4215 3 12C3 12.5785 3.87775 13.8124 5.37974 14.8789C7.23713 16.1978 9.60476 17 12 17C14.3952 17 16.7629 16.1978 18.6203 14.8789C20.1223 13.8124 21 12.5785 21 12C21 11.4215 20.1223 10.1876 18.6203 9.1211C16.7629 7.80223 14.3952 7 12 7Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PasswordShowOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
